// This is a simple Box that indicates scrollable content with inset shadows.

import { useEffect, useRef } from 'react';

import './ScrollableBox.css';

export const ScrollableBox = ({ children }) => {
  const wrapper = useRef(null);
  const shadowTop = useRef(null)
  const shadowBottom = useRef(null);
  const content = useRef(null);
  const observer = useRef(null);

  const onScroll = (e) => {
    if (!content.current) {
      return;
    }
    const scrollTop = e ? e.target.scrollTop : content.current.scrollTop;
    const scrollHeight = content.current?.scrollHeight;
    const offsetHeight = wrapper.current?.offsetHeight;
    
    const topOpacity = (scrollHeight - offsetHeight) === 0
      ? 0
      : scrollTop / (scrollHeight - offsetHeight);
    
    const botOpacity = (scrollHeight - offsetHeight) === 0
      ? 0
      : 1 - (scrollTop / (scrollHeight - offsetHeight));

    requestAnimationFrame(() => {
      shadowTop.current.style.opacity = topOpacity;
      shadowBottom.current.style.opacity = botOpacity;
    })
  }

  useEffect(() => {
    if (!observer.current) {
      observer.current = new ResizeObserver((entries) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const _entry of entries) {
          onScroll();
        }
      });
    }

    // TODO: This is a super dirty hack, it would be best to provide a Context so that the observer can be subscribed to children specifically.
    // eslint-disable-next-line no-restricted-syntax
    for (const child of content.current.children) {
      // eslint-disable-next-line no-restricted-syntax
      for (const child2 of child.children) {
        observer.current.observe(child2);
      }
    }

    return () => {
      observer.current.disconnect();
    }
  }, []);

  return <div ref={wrapper} className="h-full relative">
    <div ref={shadowTop} className="gshadow gshadow--top" />
    <div ref={shadowBottom} className="gshadow gshadow--bottom" />
    <div
      ref={content}
      className="h-full"
      style={{
        overflowY: 'scroll'
      }}
      onScroll={onScroll}>
      { children }
    </div>
  </div>
};

export default ScrollableBox;
